import React from 'react';
import { Redirect } from 'react-router-dom';
import SubDocument from '../SubDocument'
import Hospital from '../Hospital';
import AddDocument from '../AddDocument';
import HandleSubmission from '../HandleSubmission'

import {
  Card,
  CardBody,
  Row,
  Form
} from 'reactstrap'

const ChildForm = (props) => {

  if(props.status.success == true) {
    return <Redirect to="/childrecord" />
  }

  return (
    <Card>
      <CardBody>
        <Form onSubmit={props.handleSubmit}>
          <Row>
            <SubDocument 
              subDocuments={props.status.subDocumentsOption}
              subDocumentType={props.values.subDocumentType}
              setFieldValue={props.setFieldValue}
              errors={props.errors}
              touched={props.touched}
              />
          </Row>
          <Hospital values={props.values}
            handleChange={props.handleChange}
            errors={props.errors}
            touched={props.touched}
          />          
          <React.Fragment>
            <AddDocument 
              type={props.values.type}
              category={props.values.category}
              documentType={props.status.documentType}
              documentsOption={props.values.documentsOption}
              title={props.values.document.title} 
              description={props.values.document.description}
              appointment={props.values.document.appointment}
              fileInputKey={props.submitCount}
              handleChange={props.handleChange}
              setFieldValue={props.setFieldValue}
              files={props.values.files}
              uploadedFiles={props.status.files}
              formType={props.formType}
              deleteImage={props.deleteImage}
              errors={props.errors}
              touched={props.touched}
            />    
          </React.Fragment>
          <HandleSubmission 
            setFieldValue={props.setFieldValue}
            submitForm={props.submitForm}
            formType={props.formType}
          />
        </Form>
      </CardBody>
    </Card>
  )
}


export default ChildForm;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/ChildRecord/ChildForm.js